<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="71.22"
    height="41.526"
    viewBox="0 0 71.22 41.526"
  >
    <g transform="translate(-252.264 -10)">
      <path
        d="M-35.736-5.292v1.224h10.92V-5.292Zm22.944-2.724v-.876h-3.4a9.1,9.1,0,0,0,.336-.96l-1-.228a7.275,7.275,0,0,1-1.488,2.82,6.5,6.5,0,0,1,.876.576,6.741,6.741,0,0,0,.876-1.332Zm-.324,2.172V-6.72h-3.936v.876Zm-8.94-.852h1.068v.552h-1.068ZM-20.988-9v.492h-1.068V-9ZM-19.4-7.332h-2.652v-.54H-19.4Zm1.368,1.188h-2.052V-6.7h1.656V-8.508h-1.656V-9H-18.2v-.66h-4.872v4.188h5.04ZM-20.82-2.268h5.244v.516H-20.82Zm0-1.1h5.244v.5H-20.82Zm0-1.1h5.244v.5H-20.82ZM-15.852-.06c-.516,0-.6-.036-.6-.324v-.732h1.968V-5.088h-7.392v3.972h1.632c-.336.732-1.14,1.056-3.408,1.224a2.63,2.63,0,0,1,.48.852C-20.472.684-19.5.1-19.116-1.116h1.572v.744c0,.936.312,1.188,1.572,1.188h1.884c.96,0,1.272-.3,1.38-1.572a3.693,3.693,0,0,1-.948-.348c-.048.912-.12,1.044-.54,1.044Zm9.168-9.348-1.4-.144a13.413,13.413,0,0,1-.276,2.58c-.684.06-1.332.108-1.716.12-.408.012-.756.024-1.164,0l.12,1.3c.336-.06.888-.132,1.188-.168.276-.036.768-.1,1.32-.156a19.044,19.044,0,0,1-2.5,5.844l1.236.492A25.056,25.056,0,0,0-7.392-6c.456-.048.852-.072,1.1-.072.756,0,1.224.18,1.224,1.212A9.753,9.753,0,0,1-5.6-1.344a.94.94,0,0,1-.984.576,6.249,6.249,0,0,1-1.464-.24L-7.86.24A6.748,6.748,0,0,0-6.432.408,1.766,1.766,0,0,0-4.584-.636,11.619,11.619,0,0,0-3.9-4.992c0-1.68-.876-2.148-2.04-2.148-.276,0-.708.024-1.2.072.108-.564.216-1.14.288-1.512C-6.8-8.844-6.744-9.156-6.684-9.408ZM-2.544-8.2l-1.116.48a14.322,14.322,0,0,1,2.076,4.44L-.4-3.828A20.783,20.783,0,0,0-2.544-8.2Zm6.612-1.32-.3,1.14c.924.24,3.564.792,4.74.948l.276-1.164A35.168,35.168,0,0,1,4.068-9.516ZM3.96-7.236,2.688-7.4a45.007,45.007,0,0,1-.612,4.932l1.1.264a2.442,2.442,0,0,1,.408-.636,4.5,4.5,0,0,1,3.54-1.524c1.152,0,1.98.636,1.98,1.524,0,1.584-1.872,2.58-5.58,2.112L3.888.5C8.58.9,10.4-.66,10.4-2.82c0-1.428-1.224-2.616-3.18-2.616A5.777,5.777,0,0,0,3.48-4.1C3.588-4.836,3.792-6.48,3.96-7.236Zm16.428-.936v1.944c0,.912.216,1.188,1.164,1.188H22.62c.72,0,.984-.3,1.092-1.5a2.9,2.9,0,0,1-.9-.372c-.024.864-.072.984-.3.984h-.8c-.264,0-.3-.036-.3-.312V-8.172ZM17.6-8.508h4.872v1.26h1V-9.456H16.656V-7.2H17.6Zm.888.36c-.072,1.44-.384,2.184-2.112,2.592a2.467,2.467,0,0,1,.552.8c2.052-.552,2.472-1.572,2.592-3.4Zm-2.268,3.1-1.092.324v-1.98h1.2V-7.74h-1.2v-2.316h-1.02V-7.74H12.72v1.032h1.392v2.28c-.588.168-1.128.324-1.56.432l.252,1.08c.4-.132.84-.264,1.308-.408V-.288c0,.168-.06.2-.216.2-.132.012-.576.012-1.056,0a3.562,3.562,0,0,1,.3,1.032,3.58,3.58,0,0,0,1.56-.2c.324-.18.432-.48.432-1.032V-3.636c.408-.132.828-.264,1.236-.4Zm7.32,2.124v-1H20.52V-5.172H19.428v1.248h-2.94v1h2.28A6.821,6.821,0,0,1,15.8-.36a4.443,4.443,0,0,1,.72.852,7.6,7.6,0,0,0,2.9-2.7V.936H20.52V-2.22a8.55,8.55,0,0,0,2.6,2.64,4.032,4.032,0,0,1,.756-.864,7.447,7.447,0,0,1-2.712-2.484Zm8.424-6.648h-1.38c.024.12.06.492.1.876.012.144.012.348.024.612-1.716.024-3.948.084-5.3.108l.036,1.152c1.488-.1,3.456-.168,5.28-.192,0,.348.012.708.012,1.02a2.4,2.4,0,0,0-.672-.084,2.167,2.167,0,0,0-2.232,2.16,2,2,0,0,0,2.016,2.088,1.88,1.88,0,0,0,.84-.18,4.611,4.611,0,0,1-3.1,1.764L28.608.756c2.844-.828,3.7-2.712,3.7-4.308a2.956,2.956,0,0,0-.42-1.6c0-.54,0-1.236-.012-1.884,1.74,0,2.88.024,3.588.06L35.484-8.1h-3.6c0-.24,0-.456.012-.6A6.993,6.993,0,0,1,31.968-9.576ZM28.956-3.948a1.081,1.081,0,0,1,1.092-1.128.989.989,0,0,1,.936.576c.156,1.128-.312,1.62-.936,1.62A1.053,1.053,0,0,1,28.956-3.948Z"
        transform="translate(288 50)"
        fill="currentColor"
      />
      <template v-if="active">
        <g transform="translate(288.098 21.321)">
          <g transform="translate(-12.098 -9.321)">
            <path
              d="M4.472,2.186A2.186,2.186,0,1,1,3.814.622a2.186,2.186,0,0,1,.658,1.564"
              transform="translate(-0.05 0.001)"
              fill="#ad393a"
            />
            <line x2="14.905" transform="translate(7.8 2.186)" fill="#ad393a" />
            <line
              x2="14.905"
              transform="translate(7.8 2.186)"
              fill="none"
              stroke="#ad393a"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="2.981"
            />
            <path
              d="M4.472,16.586A2.186,2.186,0,1,1,2.286,14.4a2.186,2.186,0,0,1,2.186,2.186"
              transform="translate(-0.05 -7.246)"
              fill="#ad393a"
            />
            <line x2="14.905" transform="translate(7.8 9.34)" fill="#ad393a" />
            <line
              x2="14.905"
              transform="translate(7.8 9.34)"
              fill="none"
              stroke="#ad393a"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="2.981"
            />
            <path
              d="M4.472,30.886A2.186,2.186,0,1,1,2.286,28.7a2.186,2.186,0,0,1,2.186,2.186"
              transform="translate(-0.05 -14.441)"
              fill="#ad393a"
            />
            <line
              x2="14.905"
              transform="translate(7.8 16.445)"
              fill="#ad393a"
            />
            <line
              x2="14.905"
              transform="translate(7.8 16.445)"
              fill="none"
              stroke="#ad393a"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="2.981"
            />
          </g>
        </g>
      </template>
      <template v-else>
        <g transform="translate(288.353 21.6)">
          <g transform="translate(-11.353 -8.6)">
            <path
              d="M2.981,1.491A1.491,1.491,0,1,1,1.491,0,1.491,1.491,0,0,1,2.981,1.491"
              fill="#999"
            />
            <line x2="14.905" transform="translate(7.055 1.491)" fill="#999" />
            <line
              x2="14.905"
              transform="translate(7.055 1.491)"
              fill="none"
              stroke="#999"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="1.491"
            />
            <path
              d="M2.981,15.791A1.491,1.491,0,1,1,1.491,14.3a1.491,1.491,0,0,1,1.491,1.491"
              transform="translate(0 -7.195)"
              fill="#999"
            />
            <line x2="14.905" transform="translate(7.055 8.595)" fill="#999" />
            <line
              x2="14.905"
              transform="translate(7.055 8.595)"
              fill="none"
              stroke="#999"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="1.491"
            />
            <path
              d="M2.981,30.091A1.491,1.491,0,1,1,1.491,28.6a1.491,1.491,0,0,1,1.491,1.491"
              transform="translate(0 -14.391)"
              fill="#999"
            />
            <line x2="14.905" transform="translate(7.055 15.7)" fill="#999" />
            <line
              x2="14.905"
              transform="translate(7.055 15.7)"
              fill="none"
              stroke="#999"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="1.491"
            />
          </g>
        </g>
      </template>
    </g>
  </svg>
</template>

<script lang="ts" src="./FooterMenuIconList.ts"></script>
